import { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Delete } from 'assets/icons/Delete.svg';
import ConfirmationModal from 'components/ConfirmationModal';
import { DefaultRoleTypesEnum } from 'modules/Workspaces/hooks/useCreateWorkspaceRole/utils';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

import DeleteRoleCascadeMessage from './DeleteRoleCascadeMessage';
import useDeleteWorkspaceRole from './useDeleteWorkspaceRole';

const useDeleteRoleModal = () => {
  const { t } = useTranslation();
  const { roleAssignments, workspaceRoles } = useWorkspacesContext({ requireWorkspaceId: true });

  const confirmationModal = useModal(ConfirmationModal);
  const { deleteWorkspaceRole } = useDeleteWorkspaceRole();

  const showDeleteRoleModal = (id: string, name: string, onSuccess: () => void) => {
    const role = workspaceRoles.find((entry) => entry.id === id);
    const isDefaultRole =
      role?.defaultRoleType === DefaultRoleTypesEnum.OWNER || role?.defaultRoleType === DefaultRoleTypesEnum.MEMBER;
    const assignmentCount = roleAssignments.filter(({ roleId }) => roleId === id).length;

    return confirmationModal.show({
      icon: Delete,
      message: (
        <DeleteRoleCascadeMessage
          roleId={id}
          name={name}
          isDefaultRole={isDefaultRole}
          assignmentCount={assignmentCount}
        />
      ),
      confirmButtonText: t('remove'),
      onConfirm: () => deleteWorkspaceRole(id, onSuccess),
    });
  };

  return showDeleteRoleModal;
};

export default useDeleteRoleModal;
